var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApproved = function SvgApproved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.5L21.3382 8.44429L21.7091 4.40286L17.7709 3.50476L15.7091 0L12 1.59905L8.29091 0L6.22909 3.49381L2.29091 4.38095L2.66182 8.43333L0 11.5L2.66182 14.5557L2.29091 18.6081L6.22909 19.5062L8.29091 23L12 21.39L15.7091 22.989L17.7709 19.4952L21.7091 18.5971L21.3382 14.5557L24 11.5ZM9.91636 16.6695L5.77091 12.4967L7.38545 10.8757L9.91636 13.4276L16.2982 6.99857L17.9127 8.61952L9.91636 16.6695Z",
    fill: "currentColor"
  })));
};
export default SvgApproved;